import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { TextBlockConfig } from '@front-platform/content-builder';
import { textBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
export interface TextBlockRuntimeConfig {}

export type TextBlockConfigInput = Partial<
  Omit<TextBlockConfig, keyof TextBlockRuntimeConfig> & TextBlockRuntimeConfig
>;
export type TextBlockResolvedConfig = Omit<TextBlockConfig, keyof TextBlockRuntimeConfig> &
  Partial<TextBlockRuntimeConfig>;
export interface TextBlockContract extends ConfigComponentContract<
  TextBlockConfigInput,
  TextBlockResolvedConfig
> {}

@Component({
  selector: 'app-text-block',
  templateUrl: './text-block.component.html',
  standalone: false,
})
export class TextBlockComponent implements TextBlockContract {
  readonly config = input<TextBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<TextBlockConfig, TextBlockRuntimeConfig>(
    textBlockResolveConfig,
    () => ({ config: this.config() }),
  );
  get content(): string {
    return this.resolvedConfig()['content'] as unknown as string;
  }
  get width(): string {
    return this.resolvedConfig()['width'] as unknown as string;
  }
  get withoutPadding(): boolean {
    return this.resolvedConfig()['without_padding'] as unknown as boolean;
  }
  get withoutContainer(): boolean {
    return this.resolvedConfig()['without_container'] as unknown as boolean;
  }
  get topMargin(): string {
    return this.resolvedConfig()['top_margin'] as unknown as string;
  }
  get bottomMargin(): string {
    return this.resolvedConfig()['bottom_margin'] as unknown as string;
  }
  get textColor(): IContentBuilderFieldColor {
    return this.resolvedConfig()['text_color'] as unknown as IContentBuilderFieldColor;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(TextBlockComponent, { 'keyAliases': {} });
